import { useCallback, useState } from 'react';

import { Box, IconButton, Paragraph } from '@zillow/constellation-10';
import { IconChevronDownFilled, IconChevronUpFilled } from '@zillow/constellation-icons';

interface QuestionAnswerProps {
  question: string;
  answer: string;
  i: number;
}

const QuestionAnswer: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<QuestionAnswerProps>>> = (
  props,
) => {
  const { question, answer, i } = props;
  const [expanded, setExpanded] = useState(false);
  const expand = useCallback(() => setExpanded(!expanded), [expanded]);
  return (
    <>
      <Box css={{ _mobile: { display: 'flex', alignItems: 'baseline' } }}>
        <Paragraph textStyle="body-bold" css={{ marginBottom: '400', _mobile: { width: '80%' } }}>
          {i + 1}. {question}
        </Paragraph>
        <IconButton
          icon={expanded ? <IconChevronUpFilled /> : <IconChevronDownFilled />}
          emphasis="bare"
          title={expanded ? 'Collapse' : 'Expand'}
          size="sm"
          onClick={expand}
          css={{ width: '20%', borderWidth: 0, _aboveMobile: { display: 'none' } }}
        />
      </Box>
      <Paragraph color="text.subtle" css={{ marginBottom: '800', ...(!expanded && { _mobile: { srOnly: true } }) }}>
        <div dangerouslySetInnerHTML={{ __html: answer }} />
      </Paragraph>
    </>
  );
};

export default QuestionAnswer;
